/**
 * Swap SKU note from custom.sku_description_kc on on:variant:change.
 * Empty metafield → hide note (no leftover from previous variant).
 */
(function () {
  'use strict';

  function parseMap(root) {
    var el = root.querySelector('[data-kc-sku-desc-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function apply(root, variantId) {
    if (!root) return;
    var map = parseMap(root);
    var text = '';
    if (variantId != null && Object.prototype.hasOwnProperty.call(map, String(variantId))) {
      text = map[String(variantId)];
    }
    if (text == null) text = '';
    text = String(text).trim();

    var textEl = root.querySelector('[data-kc-sku-desc-text]');
    if (textEl) textEl.textContent = text;

    if (text) root.removeAttribute('hidden');
    else root.setAttribute('hidden', '');
  }

  function syncFromEvent(evt) {
    var variant = evt && evt.detail && evt.detail.variant;
    var id = variant && variant.id != null ? variant.id : null;
    document.querySelectorAll('[data-kc-sku-desc]').forEach(function (root) {
      apply(root, id);
    });
  }

  document.addEventListener('on:variant:change', syncFromEvent);
})();
